import { AdminActionLogListPage } from '@/general/src/actionLog/pages/AdminActionLogListPage/index.js'
import { AdminAccountPage } from '@/general/src/admin/pages/AdminAccountPage/index.js'
import { AdminAdminEditPage } from '@/general/src/admin/pages/AdminAdminEditPage/index.js'
import { AdminAdminListPage } from '@/general/src/admin/pages/AdminAdminListPage/index.js'
import { AdminAdminNewPage } from '@/general/src/admin/pages/AdminAdminNewPage/index.js'
import { AdminAgentEditPage } from '@/general/src/agent/pages/AdminAgentEditPage/index.js'
import { AdminAgentListPage } from '@/general/src/agent/pages/AdminAgentListPage/index.js'
import { AdminAgentNewBatchPage } from '@/general/src/agent/pages/AdminAgentNewBatchPage/index.js'
import { AdminAgentNewPage } from '@/general/src/agent/pages/AdminAgentNewPage/index.js'
import { AgentAccountPage } from '@/general/src/agent/pages/AgentAccountPage/index.js'
import { AdminSignInPage } from '@/general/src/auth/pages/webapp/AdminSignInPage/index.js'
import { AdminSignOutPage } from '@/general/src/auth/pages/webapp/AdminSignOutPage/index.js'
import { AgentResetPasswordPage } from '@/general/src/auth/pages/webapp/AgentResetPasswordPage/index.js'
import { AgentRestorePasswordPage } from '@/general/src/auth/pages/webapp/AgentRestorePasswordPage/index.js'
import { AgentSignInPage } from '@/general/src/auth/pages/webapp/AgentSignInPage/index.js'
import { AgentSignOutPage } from '@/general/src/auth/pages/webapp/AgentSignOutPage/index.js'
import { AdminInsuranceCampaignListPage } from '@/general/src/insuranceCampaign/webapp/AdminInsuranceCampaignListPage/index.js'
import { AdminInsuranceCampaignViewPage } from '@/general/src/insuranceCampaign/webapp/AdminInsuranceCampaignViewPage/index.js'
import { AdminIssuesStatsPage } from '@/general/src/insuranceCampaign/webapp/AdminIssuesStatsPage/index.js'
import { AdminOrganizationListPage } from '@/general/src/organization/pages/AdminOrganizationListPage/index.js'
import { AdminOrganizationNewPage } from '@/general/src/organization/pages/AdminOrganizationNewPage/index.js'
import { AdminOrganizationViewPage } from '@/general/src/organization/pages/AdminOrganizationViewPage/index.js'
import { AdminTxListPage } from '@/general/src/subscription/webapp/pages/AdminTxListPage/index.js'
import { PlansPage } from '@/general/src/subscription/webapp/pages/PlansPage/index.js'
import { AdminUpgradePostEditPage } from '@/general/src/upgradePost/pages/AdminUpgradePostEditPage/index.js'
import { AdminUpgradePostListPage } from '@/general/src/upgradePost/pages/AdminUpgradePostListPage/index.js'
import { AdminUpgradePostNewPage } from '@/general/src/upgradePost/pages/AdminUpgradePostNewPage/index.js'
import { PublicUpgradePostListPage } from '@/general/src/upgradePost/pages/PublicUpgradePostListPage/index.webapp.js'
import { NotFoundPageComponent } from '@/webapp/src/components/errors/NotFoundPageComponent/index.js'
import { GeneralLayout } from '@/webapp/src/components/layout/GeneralLayout/index.js'
import { AnchorClickListener } from '@/webapp/src/lib/anchor.js'
import { AppContextPreloader } from '@/webapp/src/lib/ctx.js'
import * as routes from '@/webapp/src/lib/routes.js'
import '@/webapp/src/lib/sentry.js'
import { Toaster } from '@/webapp/src/lib/toaster.js'
import { TrpcProvider } from '@/webapp/src/lib/trpc.js'
import { ProgressLine } from '@/webapp/src/lib/uninty.components.js'
import { WindowSizeWatcher } from '@/webapp/src/lib/windowSize.js'
import { DocOfertaPage } from '@/webapp/src/pages/docs/DocOfertaPage/index.js'
import { DocPolitikaPage } from '@/webapp/src/pages/docs/DocPolitikaPage/index.js'
import { DocSoglasheniePage } from '@/webapp/src/pages/docs/DocSoglasheniePage/index.js'
import { DocSoglasiePage } from '@/webapp/src/pages/docs/DocSoglasiePage/index.js'
import { DownloadPage } from '@/webapp/src/pages/other/DownloadPage/index.js'
import { HomePage } from '@/webapp/src/pages/other/HomePage/index.js'
import '@/webapp/src/styles/global.scss'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
;(BigInt.prototype as any).toJSON = function () {
  return this.toString()
}

export const App = () => {
  return (
    <HelmetProvider>
      <TrpcProvider>
        <AppContextPreloader>
          <BrowserRouter>
            <AnchorClickListener />
            <ProgressLine />
            <WindowSizeWatcher />
            <Toaster />
            <Routes>
              <Route path={routes.homeRoute.definition} element={<HomePage />} />
              <Route path={routes.downloadRoute.definition} element={<DownloadPage />} />
              <Route path={routes.plansRoute.definition} element={<PlansPage />} />
              <Route path={routes.docOfertaRoute.definition} element={<DocOfertaPage />} />
              <Route path={routes.docPolitikaRoute.definition} element={<DocPolitikaPage />} />
              <Route path={routes.docSoglashenieRoute.definition} element={<DocSoglasheniePage />} />
              <Route path={routes.docSoglasieRoute.definition} element={<DocSoglasiePage />} />

              <Route path={routes.agentSignInRoute.definition} element={<AgentSignInPage />} />
              <Route path={routes.agentRestorePasswordRoute.definition} element={<AgentRestorePasswordPage />} />
              <Route path={routes.agentResetPasswordRoute.definition} element={<AgentResetPasswordPage />} />
              <Route path={routes.agentSignOutRoute.definition} element={<AgentSignOutPage />} />

              <Route path={routes.agentAccountRoute.definition} element={<AgentAccountPage />} />

              <Route path={routes.adminSignOutRoute.definition} element={<AdminSignOutPage />} />
              <Route path={routes.adminSignInRoute.definition} element={<AdminSignInPage />} />

              <Route path={routes.adminAccountRoute.definition} element={<AdminAccountPage />} />
              <Route path={routes.adminActionLogsRoute.definition} element={<AdminActionLogListPage />} />

              <Route path={routes.adminAdminListRoute.definition} element={<AdminAdminListPage />} />
              <Route path={routes.adminAdminNewRoute.definition} element={<AdminAdminNewPage />} />
              <Route path={routes.adminAdminEditRoute.definition} element={<AdminAdminEditPage />} />

              <Route path={routes.adminAgentListRoute.definition} element={<AdminAgentListPage />} />
              <Route path={routes.adminAgentNewRoute.definition} element={<AdminAgentNewPage />} />
              <Route path={routes.adminAgentNewBatchRoute.definition} element={<AdminAgentNewBatchPage />} />
              <Route path={routes.adminAgentEditRoute.definition} element={<AdminAgentEditPage />} />

              <Route path={routes.adminAdminListRoute.definition} element={<AdminAdminListPage />} />
              <Route path={routes.adminAdminNewRoute.definition} element={<AdminAdminNewPage />} />
              <Route path={routes.adminAdminEditRoute.definition} element={<AdminAdminEditPage />} />

              <Route path={routes.adminOrganizationListRoute.definition} element={<AdminOrganizationListPage />} />
              <Route path={routes.adminOrganizationNewRoute.definition} element={<AdminOrganizationNewPage />} />
              <Route path={routes.adminOrganizationViewRoute.definition} element={<AdminOrganizationViewPage />} />

              <Route path={routes.adminUpgradePostListRoute.definition} element={<AdminUpgradePostListPage />} />
              <Route path={routes.adminUpgradePostNewRoute.definition} element={<AdminUpgradePostNewPage />} />
              <Route path={routes.adminUpgradePostEditRoute.definition} element={<AdminUpgradePostEditPage />} />
              <Route path={routes.publicUpgradePostListRoute.definition} element={<PublicUpgradePostListPage />} />

              <Route path={routes.adminTxListRoute.definition} element={<AdminTxListPage />} />
              <Route path={routes.adminIssuesStatsRoute.definition} element={<AdminIssuesStatsPage />} />
              <Route
                path={routes.adminInsuranceCampaignListRoute.definition}
                element={<AdminInsuranceCampaignListPage />}
              />
              <Route
                path={routes.adminInsuranceCampaignViewRoute.definition}
                element={<AdminInsuranceCampaignViewPage />}
              />

              <Route
                path="*"
                element={
                  <GeneralLayout>
                    <NotFoundPageComponent />
                  </GeneralLayout>
                }
              />
            </Routes>
          </BrowserRouter>
        </AppContextPreloader>
      </TrpcProvider>
    </HelmetProvider>
  )
}
